import styled from "styled-components";

const MainTitle = styled.h1`
	color: #f0f0f0;
	font-size: 6rem;
	font-weight: 800;
	margin: 8px 0px 16px 0px;
`;

export default MainTitle;